import React, {Fragment, useState, useEffect, useContext, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import Layout from 'components/sales/layout/layout';
import LeadDetail from 'components/sales/leadDetails/createLeadDetail/leadDetail';
import Notfound from 'pages/notfound';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { Button,Table } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import DivLayout from 'components/sales/divLayout/divLayout';
import { STATUS } from 'constants/statusConstant';
import './viewDetail.css';
import GoogleMapReact from 'google-map-react';
import {toast} from "react-toastify";
import checkbox from "../../../../components/sales/Input/checkbox/checkbox";
import ApprovalView from "./ApprovalView";
import ProjectMappingDetails from "./projectMappingDetails";



const ViewDetails = ({ 
  acceptLeadApproval,
  rejectLeadApproval,
  getExistingProject,
  existingProjectList,
  viewDetails, 
  getDetails, 
  match,
  infraProjectMap,
  mappedInfraProject = [],
  projectMappingDetails: fetchProjectMappingDetails,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [details, setDetails] = useState(null);
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [leadId, setleadId] = useState();
  const [teamId, setTeamId] = useState();
  const [isRender, setIsRender] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [actionData, setActionData] = useState();
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [showProjectListPopup, setShowProjectListPopup] = useState(false);
  const [finalApproval, setFinalApproval] = useState(false);
  const [approvalView, setApprovalView] = useState(false)
  const [roleId, setRoleId] = useState()
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [showProjectMappingDetailsPopup, setShowProjectMappingDetailsPopup] = useState(false);
  const [projectMappingDetailsData, setProjectMappingDetailsData] = useState(null);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedMappingOption, setSelectedMappingOption] = useState({
    type: null,
    details: null,
  });
  const isComponentMounted = useRef(true);

  useEffect(() => {
    return () => {
      isComponentMounted.current = false;
    };
  }, []);
  const input = {
    remarks: '',
  };
  const [remarks, setRemarks] = useState(input);
  const [projects, setProjects] = useState(null);
  useEffect(() => {
    if (existingProjectList) {
      setProjects(existingProjectList?.projects);
    }
  }, [existingProjectList]);

  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].team_id;
      // let leadTypeId =
      //   (await JSON.parse(localStorage.getItem('viewDetail'))) &&
      //   JSON.parse(localStorage.getItem('viewDetail'))[0].lead_type_id;

      // if(leadTypeId === undefined){
      //  leadTypeId = (await JSON.parse(localStorage.getItem('viewDetail'))) &&
      //   JSON.parse(localStorage.getItem('viewDetail'))[0].lead_type?.id;
      // }

      let leadTypeId = match.params.type;

      setRoleId(localStorage.getItem('fusion-role'))
      setTeamId(team);
      const requestData = {
        lead_id: leadId,
        lead_type: leadTypeId,
      };

      if (leadId) {
        setIsLoading(true);
        const res = await getDetails(requestData);
        setIsLoading(false);
        if (res === null || res === '') {
          setIsRender(true);
        }
      }
    })();
  }, [getDetails, leadId]);

  useEffect(() => {
    if (viewDetails) {
      setDetails(viewDetails);
      if(viewDetails?.lead_data?.latitude){
        setLat(viewDetails?.lead_data?.latitude);
      }

      if(viewDetails?.lead_data?.longitude){
        setLng(viewDetails?.lead_data?.longitude);
      }
      
    }
    setleadId(match.params.id);
  }, [viewDetails]);

  function renderMarkers(map, maps) {
    let marker = new maps.Marker({
      position: {
        lat: Number(lat),
        lng: Number(lng),
      },
      map,
      title: 'You are here!'
    });
  } 


  const updateApproval = async (data, clientName='') => {
    setActionData(data);
    setDisableSubmitButton(true)
    if (data === 'accept') {
      const requestData = {
        lead_id: leadId,
        client_name: clientName,
        remarks: '',
      };
      setIsLoading(true);
      setApprovalView(false)
      await acceptLeadApproval(requestData).then(async (response) => {
        if (response) {
          setIsLoading(false);
          setIsModal(true);

        }else{
          setIsLoading(false);
        }
      });
      setDisableSubmitButton(false)
    } else {
      setIsModal(true);
      setIsLoading(false);
    }
  };

  const closePopup = () => {
    setShowProjectListPopup(false);
  
  }

  const checkInfraId = () => {
    (async () => {
        setIsLoading(true);
        let res = await getExistingProject(details?.lead_data);
        setShowProjectListPopup(true);
        setIsLoading(false);
      })();
  };

  const handleContinue = async () => {
    setIsModal(false);
    const requestData = {
      lead_id: leadId,
      remarks: remarks.remarks,
    };
    setIsLoading(true);
    await rejectLeadApproval(requestData).then(async (response) => {
      setIsLoading(false);
      if (response) {
      
        setIsSuccessModel(true);
      }
    });
  };

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        {/* onClick={func} */}
        <Link to="/dashboard/lead_approvals" className="btn btn-transparent">
          {localization.returnToApproval}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </div>
    );
  };
  const handleModalHide = () => setIsModal(false);
  const handleModalApprovalViewHide = () => setApprovalView(false);
  const handleRejectModalHide = () => setIsSuccessModel(false);
  const closeProjectMappingDetailsPopup = () => {
    if (!isComponentMounted.current) return;
    setShowProjectMappingDetailsPopup(false);
    setProjectMappingDetailsData(null);
    setSelectedProjectId(null);
    setSelectedMappingOption({ type: null, details: null });
  };

  const handleAddressSelection = useCallback((type, entity) => {
    if (!isComponentMounted.current) return;
    setSelectedMappingOption({ type, details: entity });
  }, []);

  const headerBtns = () => {
    return (
      <Fragment>
        {parseInt(roleId) !== 55 &&
            <Link
                to={{
                  pathname: `${baseUrl}/edit-project/${leadId}`,
                }}
                className="btn btn-primary d-md-inline-block"
            >
              {localization.editProject}
              <img src={Images?.ArrowRight} alt="" />
            </Link>
        }
          </Fragment>

    );
  };

  const handleMapProject = async (infraId) => {
    if (typeof document !== 'undefined' && document.activeElement) {
      const target = document.activeElement;
      if (target instanceof HTMLElement) {
        target.blur();
      }
    }
    if (!isComponentMounted.current) {
      return;
    }
    setIsLoading(true);
    try {
      const payload = {
        lead_id: match?.params?.id,
        project_id: infraId,
      };
      const response = await fetchProjectMappingDetails(payload);
      if (response?.data) {
        if (isComponentMounted.current) {
          setProjectMappingDetailsData(response.data);
          setShowProjectMappingDetailsPopup(true);
          setSelectedProjectId(infraId);
        }
      } else {
        toast.error(response?.message || 'Unable to fetch mapping details.');
      }
    } catch (error) {
      toast.error('Unable to fetch mapping details.');
    } finally {
      if (isComponentMounted.current) {
        setIsLoading(false);
      }
    }
  }

  const handleConfirmAddress = useCallback((type, entity) => {
    if (!selectedProjectId) {
      toast.error('Project not selected.');
      return;
    }
    if (!entity || !entity.lead_address_details) {
      toast.error('Address data is missing. Please try again.');
      return;
    }
    
    const addressId = entity.lead_address_details?.id;
    if (!addressId) {
      toast.error('Address ID is missing. Please try again.');
      return;
    }
    
    const payload = {
      lead_id: match?.params?.id,
      infra_id: selectedProjectId,
      selected_address_lead_id: entity.lead_id,
      selected_address_id: addressId,
      selected_address_type: type,
    };
    if (!isComponentMounted.current) {
      return;
    }
    setIsLoading(true);
    (async () => {
      try {
        const response = await infraProjectMap(payload);
        if (response?.status === false) {
          toast.error(response?.message || 'Unable to map project.');
          return;
        }
        closeProjectMappingDetailsPopup();
      } catch (error) {
        toast.error('Unable to map project.');
      } finally {
        if (isComponentMounted.current) {
          setIsLoading(false);
        }
      }
    })();
  }, [selectedProjectId, match?.params?.id, infraProjectMap, closeProjectMappingDetailsPopup]);

  useEffect(() => {
    if(mappedInfraProject.status && parseInt(mappedInfraProject?.status) === 200){
      setShowProjectListPopup(false)
        toast.success(mappedInfraProject?.message);

      setTimeout(() => {
        window.location.href=`${baseUrl}/lead_approvals`
      }, 500)

    }  else if(mappedInfraProject.status && parseInt(mappedInfraProject?.status) !== 200){
        toast.error(mappedInfraProject?.message);

      setTimeout(() => {
        window.location.href=`${baseUrl}/lead_approvals`
      }, 500)
    }
  }, [mappedInfraProject])

  return isRender ? (
    <Notfound />
  ) : (
    <Layout title={localization.BacktoList} 
    Buttons={headerBtns}
    isLoading={isLoading} 
    isGoback>
     

      {/* NEW DESIGN */}
  <div className="panel-card bus_panel-card blue">
    <div className="bus_row">

      <div className="col-md-7 px-3">
        <div className="bus-card-block px-6">
         
          {details?.lead_data && details?.lead_data?.client_name ? (
           <h4 className="bus-card-title mb-2">  {details.lead_data?.client_name}
           &nbsp;&nbsp;
                        {(lat && 
                          <a target="_blank" href={`http://www.google.com/maps/place/${lat},${lng}`} className="btn btn-sm btn-theme" >Go to map</a>
                        )}
           </h4>
            ) : (
              null
            )}
            {/* <h7 className="card-subtitle mb-2 text-colored  d-flex justify-content-between">
            <span className=""> <img src={Images?.Building} alt="" /> {details?.lead_data?.lead_type} </span>
            <span className="text-muted dateRight"><img src={Images?.Calendar} alt="" />{details?.lead_data?.created_at}</span></h7> */}
           <p className="bus-card-text">
           <img src={Images?.Location} alt="" /> {details?.lead_data?.address_line_one
                          ? details?.lead_data?.address_line_one
                          : localization.na}{' '}
                        {details?.lead_data?.address_line_two}
                        , &nbsp;
                        {details?.lead_data?.area}, &nbsp;
                        {details?.lead_data?.city} - 
                        {details?.lead_data?.geo_pincode} 
                        
                        
                        
           </p>
          <div className="bus-card-text">
            <div className='bus_row'>
                <div className='bus-col-6'><b>Business Type</b></div>
                <div className='bus-col-6'>{details?.lead_data?.lead_type}</div>
            </div>
            <div className='bus_row'>
                <div className='bus-col-6'><b>Source</b></div>
                <div className='bus-col-6'>{details?.lead_data?.lead_source}</div>
            </div>
            <div className='bus_row'>
                <div className='bus-col-6'><b>Assigned To</b></div>
                <div className='bus-col-6'>{details?.lead_data?.assigned_to}</div>
            </div>
            <div className='bus_row'>
                <div className='bus-col-6'><b>Created At</b></div>
                <div className='bus-col-6'>{details?.lead_data?.created_at}</div>
            </div>
            
          </div>
          {/* <p className="bus-card-text">
          <span className="text-muted"><img src={Images?.admin} alt="" />  {details?.lead_data?.assigned_to}</span>
          </p> */}
          {/* <a href="#" className="mt-auto btn btn-primary  ">Read More</a> */}
          {details && details.lead_data && (details.lead_data.project_status === 'Approved' || details.lead_data.project_status === 'Rejected') ? 
          null
        :
        <center>
          {details &&  details.lead_data  &&  (details.lead_data.area_id === '' || details.lead_data.city_id === '' || details.lead_data.city_id === 0 || details.lead_data.geo_pincode === '' || details.lead_data.geo_pincode === 0 || details.lead_data.forapproval === 0) ?
              <div className="alert alert-danger" role="alert">
                Kindly fill all required fields!
              </div>
              :
              <div className="row">
               
                
                <div className='col-md-2'>
                  <Link to="#" data-toggle="modal" data-target="#reject" className="btn btn-sm btn-danger"
                        onClick={() => updateApproval("reject")}>Reject</Link>
                </div>
                <div className='col-md-2'>
                  <Link to="#" data-toggle="modal" data-target="#accept" className="btn btn-sm btn-primary"
                        onClick={checkInfraId}>Approve</Link>

                </div>
              </div>
          }
            </center>
        }
        </div>
      </div>
      <div className="col-md-5">
        {(details?.lead_data && details?.lead_data?.latitude &&
              <GoogleMapReact
                bootstrapURLKeys={{ key: 'AIzaSyCweWEGenU5sDidT_1MKho5VoAhMC4CgtQ' }}
                defaultCenter={{
                  address: 'Delhi',
                  lat: Number(lat),
                  lng: Number(lng),
                  
                }}
                Animation = {{
                  BOUNCE:1
                }}
                defaultZoom={15}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({map, maps}) => renderMarkers(map, maps)}
            >
            </GoogleMapReact>
             )}            
        {/* <div id="CarouselTest" className="carousel slide bus_end" data-ride="carousel">
          <ol className="carousel-indicators">
            <li data-target="#CarouselTest" data-slide-to="0" className="active"></li>
            <li data-target="#CarouselTest" data-slide-to="1"></li>
            <li data-target="#CarouselTest" data-slide-to="2"></li>

          </ol>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img className="d-block" src="https://picsum.photos/450/300?image=1072" alt="" />
            </div>
            <div className="carousel-item">
              <img className="d-block" src="https://picsum.photos/450/300?image=855" alt="" />
            </div>
            <div className="carousel-item">
              <img className="d-block" src="https://picsum.photos/450/300?image=355" alt="" />
            </div>
            <a className="carousel-control-prev" href="#CarouselTest" role="button" data-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="sr-only">Previous</span>
            </a>
                      <a className="carousel-control-next" href="#CarouselTest" role="button" data-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div> */}
      </div>
      
    </div>
  </div>
 

 {/* POC DETAIL */}

 {details?.lead_data?.poc_type && (
            <>
              <div className="panel-card bus_panel-card mb-2 margin-card">
                <div className="panel-heading">{localization.pocTitle}</div>
                <div className="panel-body">
                  <div className="details-listing">
                    {teamId === STATUS.CORPORATE ||
                    teamId === STATUS.APARTMENT ? (
                      <Fragment>
                        <DivLayout
                          heading={localization.pocType}
                          data={
                            details.lead_data && details.lead_data?.poc_type
                              ? details.lead_data.poc_type
                              : localization.na
                          }
                        />
                        {details.lead_data?.poc_type === 'Other' && (
                          <DivLayout
                            heading={'Other ' + localization.pocType}
                            data={
                              details.lead_data &&
                              details.lead_data?.other_poc_sites
                                ? details.lead_data.other_poc_sites
                                : localization.na
                            }
                          />
                        )}
                      </Fragment>
                    ) : null}
                    <DivLayout
                      heading={localization.fmcName}
                      data={
                        details.lead_data?.tp_poc_details &&
                        details.lead_data.tp_poc_details?.fmc_name
                          ? details.lead_data.tp_poc_details.fmc_name
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.POCName}
                      data={
                        details.lead_data?.tp_poc_details &&
                        details.lead_data.tp_poc_details?.name
                          ? details.lead_data.tp_poc_details.name
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.designation}
                      data={
                        details.lead_data.tp_poc_details &&
                        details.lead_data.tp_poc_details?.designation
                          ? details.lead_data.tp_poc_details.designation
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.phoneNumber}
                      data={
                        details.lead_data.tp_poc_details &&
                        details.lead_data.tp_poc_details?.phone
                          ? details.lead_data.tp_poc_details.phone
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.emailAddress}
                      data={
                        details.lead_data.tp_poc_details &&
                        details.lead_data.tp_poc_details?.email
                          ? details.lead_data.tp_poc_details.email
                          : localization.na
                      }
                    />

                    <DivLayout
                      heading={localization.secondContact}
                      data={
                        details.lead_data.tp_poc_details &&
                        details.lead_data.tp_poc_details?.contact_no
                          ? details.lead_data.tp_poc_details.contact_no
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.mailCamp}
                      data={
                        details.lead_data.tp_poc_details &&
                        details.lead_data.tp_poc_details?.mail_campaign
                          ? details.lead_data.tp_poc_details.mail_campaign
                          : localization.na
                      }
                    />

                    {/* {teamId === STATUS.CORPORATE || teamId === STATUS.APARTMENT ? (
                  <DivLayout
                    heading={localization.secondaryContact}
                    data={
                      details?.lead_data.tp_poc_details?.secondary_contact
                        ? details.lead_data.tp_poc_details.secondary_contact
                        : localization.na
                    }
                  />
                ) : null} */}
                  </div>
                </div>
              </div>
            </>
          )}


{/* END NEW DESIGN */}
      <ModalPop
        title={"Existing Projects"}
        show={showProjectListPopup}
        handleModalHide={() => {closePopup();}}
      >
{/* projects */}
<Fragment>
        {projects && parseInt(roleId) !== 55 &&
            Object.keys(projects).length !== 0 && (
                <div className="panel-card">
                  <b className="text-justify">Based of the lat-long of the project you are approving. we have found ther following projects which are already present in our system. if you find correct match please maop the project instead of approving new one.</b>
                <hr/>
                <div className="panel-heading">List of existing projects accroding to your search.</div>
                <div className="panel-body">
                    <div className="details-list">
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>Project Id</th>
                            <th>Name</th>
                            <th>Address</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Pincode</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {/*{val?.lead_id && <a href={`${baseUrl}/contract-sales-listing/` + val.lead_id}>View Contracts</a>}*/}
                        {projects &&
                            projects &&
                            projects.map((val) => {
                            return (
                                <tr key={val.project_id}>
                                <td>{val.project_id}</td>
                                <td>{val.project_name}</td>
                                <td>{val.address}</td>
                                <td>{val.city}</td>
                                <td>{val.state}</td>
                                <td>{val.pincode}</td>
                                <td><button className="btn btn-primary" onClick={(e) => {handleMapProject(val?.project_id)}}>Map Project</button></td>
                                </tr>
                            );
                            })}
                        </tbody>
                    </Table>
                    </div>
                </div>
                </div>
            )}
  <div className="form-group">
    <label className="label" style={{width:"100%"}}>
                  <span className="" style={{display:"flex", width:"100%"}}>
                    <input
                        type="checkbox"
                        name={"contract_sign"}
                        onChange={(e) => setFinalApproval(e.target.checked)}
                        className="mr-2"
                        style={{width:"4%"}}
                    />
                    <span style={{width:"76%", textAlign:"justify"}}>I hereby declared that the project present on the list are not related to the project that i want to create.</span>
                  </span>
    </label>
  </div>

  {/*updateApproval("accept")*/}
        {finalApproval &&
            <Link to="#" data-toggle="modal" data-target="#accept" className="btn btn-primary"
                  onClick={() => setApprovalView(true)}>Final Approve</Link>
        }

        </Fragment>

      </ModalPop>
      {/* <Fragment>
        {details && details.lead_data && (details.lead_data.project_status === 'Approved' || details.lead_data.project_status === 'Rejected') ? 
          null
        :
        <center>
          {details && details.lead_data && (details.lead_data.area_id === '' || details.lead_data.city_id === '' || details.lead_data.city_id === 0 || details.lead_data.geo_pincode === '' || details.lead_data.geo_pincode === 0 || details.lead_data.forapproval === 0) ?
              <div className="alert alert-danger" role="alert">
                Kindly fill all required fields!
              </div>
              :
              <div className="row">
               
                <div className='col-md-6'>
                  <Link to="#" data-toggle="modal" data-target="#accept" className="btn btn-primary"
                        onClick={checkInfraId}>Approve</Link>

                </div>
                <div className='col-md-3'>
                  <Link to="#" data-toggle="modal" data-target="#reject" className="btn btn-danger"
                        onClick={() => updateApproval("reject")}>Reject</Link>
                </div>
              </div>
          }
            </center>
        }
            
        </Fragment> */}
        <ModalPop
        title={
          actionData && actionData.action === 'reject'
            ? localization.rejectConf
            : localization.conf
        }
        show={isModal}
        handleModalHide={handleModalHide}
        actionData={actionData}
      >
        {actionData && actionData === 'reject' ? (
          <Fragment>
            <div className="modal-body">
              <center>
              <div className="text-center">
                {/* <h4>Reject Project !</h4> */}
                <div className="form-group">
                 
                  <ConstantInput
                    label={localization.addRemark}
                    required
                    isStarRequired={true}
                    type="text"
                    handleChange={(val) => {
                      setRemarks({ ...setRemarks, remarks: val });
                    }}
                  />
                </div>
               
                <Button
                  className="btn btn-primary"
                  onClick={handleContinue}
                  disabled={!remarks.remarks}
                >
                  {localization.continue}{' '}
                  <img src="../images/arrow-right.png" alt="" />
                </Button>
              </div>
              </center>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {successIconBox(localization.approveSuccess, handleModalHide)}
          </Fragment>
        )}
      </ModalPop>
      <ModalPop
        title={localization.rejectSuccessfully}
        show={isSuccessModel}
        handleModalHide={handleRejectModalHide}
      >
        {successIconBox(localization.approveReject, handleRejectModalHide)}
      </ModalPop>

      <ModalPop
          title={
            "View"
          }
          show={approvalView}
          handleModalHide={handleModalApprovalViewHide}
      >
        <ApprovalView
            viewDetails={details}
            handleSubmit={updateApproval}
            disableSubmitButton={disableSubmitButton}
        />

      </ModalPop>
      <ModalPop
        title={"Choose Your Project Location"}
        show={showProjectMappingDetailsPopup}
        handleModalHide={() => {closeProjectMappingDetailsPopup();}}
        modalSize="lg"
      >
        <ProjectMappingDetails
          data={projectMappingDetailsData}
          onAddressChange={handleAddressSelection}
          onConfirm={handleConfirmAddress}
        />
      </ModalPop>
    </Layout>
  );
};


ViewDetails.propTypes = {
  viewDetails: PropTypes.any,
  getDetails: PropTypes.func,
  match: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default ViewDetails;
